/**
 * Retrieves the previous session id from query parameters
 * @returns The previous_session_id included in the url
 */
const usePreviousSessionId = (): string | undefined => {
  return getPreviousSessionIdParam();
};

export const getPreviousSessionIdParam = (): string => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  const previous_session_id = params.get('previous_session_id');
  if (previous_session_id && typeof previous_session_id === 'string') {
    return previous_session_id;
  }

  const previousSessionId = params.get('previousSessionId');
  if (previousSessionId && typeof previousSessionId === 'string') {
    return previousSessionId;
  }

  return '';
};

export default usePreviousSessionId;
